export default "__VITE_ASSET__BcJw_4gs__"